var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_505_48550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#036068",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62117 7.13664C8.23065 6.74612 7.59748 6.74612 7.20696 7.13664C6.81643 7.52717 6.81643 8.16033 7.20696 8.55086L8.62117 7.13664ZM15.8866 17.2305C16.2772 17.6211 16.9103 17.6211 17.3009 17.2305C17.6914 16.84 17.6914 16.2069 17.3009 15.8163L15.8866 17.2305ZM7.20696 15.8163C6.81643 16.2069 6.81643 16.84 7.20696 17.2305C7.59748 17.6211 8.23065 17.6211 8.62117 17.2305L7.20696 15.8163ZM17.3009 8.55086C17.6914 8.16033 17.6914 7.52717 17.3009 7.13664C16.9103 6.74612 16.2772 6.74612 15.8866 7.13664L17.3009 8.55086ZM7.20696 8.55086L11.5468 12.8907L12.961 11.4765L8.62117 7.13664L7.20696 8.55086ZM11.5468 12.8907L15.8866 17.2305L17.3009 15.8163L12.961 11.4765L11.5468 12.8907ZM11.5468 11.4765L7.20696 15.8163L8.62117 17.2305L12.961 12.8907L11.5468 11.4765ZM8.62117 17.2305L17.3009 8.55086L15.8866 7.13664L7.20696 15.8163L8.62117 17.2305Z",
    fill: "#DA0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_505_48550",
    x: -27.6,
    y: -27.6,
    width: 79.2,
    height: 79.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 13.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_505_48550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_505_48550",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXicon);
export default __webpack_public_path__ + "static/media/xicon.73af26c5a1dda02d14fc15ddff87a4cf.svg";
export { ForwardRef as ReactComponent };